import { __assign } from "tslib";
import React, { useEffect, useState } from 'react';
import { Container, Grid, MenuItem } from '@material-ui/core';
import { Input, TextPoint } from '../';
import { defaultValidateFormFields, docTypes, docTypeValueValidator } from '../../utils';
import { StepperButtons } from './stepperButtons';
var initialDocNumberForm = {
    docType: { value: '', error: false, isRequired: true },
    docNumber: { value: '', error: false, isRequired: true, validateBy: docTypeValueValidator, validateKey: 'docType' }
};
export var DocumentInfo = function (props) {
    var docInfo = props.docInfo;
    var _a = useState(__assign(__assign({}, initialDocNumberForm), { docType: __assign(__assign({}, initialDocNumberForm.docType), { value: docInfo.selectedDocType || '' }), docNumber: __assign(__assign({}, initialDocNumberForm.docNumber), { value: docInfo.docNumber || '' }) })), searchDocForm = _a[0], setSearchDocForm = _a[1];
    var _b = useState(true), searchButtonDisabled = _b[0], setSearchButtonDisabled = _b[1];
    useEffect(function () {
        setNextButton();
    }, []);
    useEffect(function () {
        if ((docInfo === null || docInfo === void 0 ? void 0 : docInfo.loading) && !docInfo.loading && !docInfo.error)
            setNextButton();
    }, [searchDocForm, docInfo]);
    var setNextButton = function (formToValidate) {
        if (formToValidate === void 0) { formToValidate = searchDocForm; }
        var _a = defaultValidateFormFields(formToValidate), isValid = _a.isValid, form = _a.form;
        setSearchButtonDisabled(!isValid || (docInfo === null || docInfo === void 0 ? void 0 : docInfo.loading));
        setSearchDocForm(form);
    };
    var handleOnChange = function (fieldToUpdate, value) {
        var _a;
        var copyForm = __assign(__assign({}, searchDocForm), (_a = {}, _a[fieldToUpdate] = __assign(__assign({}, searchDocForm[fieldToUpdate]), { value: value, error: false }), _a));
        setNextButton(copyForm);
    };
    var onKeyPress = function (e) {
        if (e.key === 'Enter' && !searchButtonDisabled)
            goToNext();
    };
    var goToNext = function () {
        return props.handleNext(searchDocForm.docType.value, searchDocForm.docNumber.value);
    };
    return (React.createElement(Container, { className: props.className + " search-by-document", maxWidth: 'sm' },
        React.createElement("h1", null,
            props.messages.TITLE,
            React.createElement(TextPoint, null)),
        React.createElement("div", { className: 'search-by-document-form' },
            React.createElement(Grid, { container: true, spacing: 3 },
                React.createElement(Grid, { item: true, xs: 12, sm: 6, className: 'form-input' },
                    React.createElement(Input, { label: props.messages.DOCUMENT_TYPE, error: searchDocForm.docType.error, defaultValue: searchDocForm.docType.value, onChange: function (value) { return handleOnChange('docType', value); }, testId: 'docType', required: true, select: true }, Object.keys(docTypes).map(function (docTypeKey) {
                        var docType = docTypes[docTypeKey];
                        return (React.createElement(MenuItem, { key: docTypeKey, value: docTypeKey }, docType.label));
                    }))),
                React.createElement(Grid, { item: true, xs: 12, sm: 6, className: 'form-input' },
                    React.createElement(Input, { label: props.messages.DOCUMENT_NUMBER, defaultValue: searchDocForm.docNumber.value, error: searchDocForm.docNumber.error, onChange: function (value) { return handleOnChange('docNumber', value); }, onKeyPress: onKeyPress, testId: 'docNumber', required: true }))),
            React.createElement(StepperButtons, { activeStep: props.actualStep, handleBack: props.handleBack, handleNext: goToNext, nextDisabled: searchButtonDisabled, messages: props.messages.BUTTONS }))));
};
//# sourceMappingURL=documentInfo.js.map